import { ref, computed } from "vue";
import { defineStore } from "pinia";
import axios from "axios";

export const useTrackStore = defineStore("TrackStore", () => {
  // State
  const loading = ref(true);
  const allTracks = ref([]);
  const filter = ref(null);
  const selectedTrack = ref(null);
  const playingTrack = ref(null);

  // Getters
  const count = computed(() => allTracks.value.length);
  const isEmpty = computed(() => count.value === 0);
  const filteredTracks = computed(() => {
    if (filter.value) {
      return allTracks.value.filter((track) => {
        if (filter.value.key === "artist") {
          return track.artistName === filter.value.value;
        } else if (filter.value.key === "bpm") {
          return track.bpm === filter.value.value;
        } else if (filter.value.key === "feeling") {
          return track.feelingNames.includes(filter.value.value);
        } else if (filter.value.key === "genre") {
          return track.genre.name === filter.value.value;
        } else if (filter.value.key === "key") {
          return track.key === filter.value.value;
        }
      });
    } else {
      return allTracks.value;
    }
  });

  // Actions
  const fill = async function fill() {
    const tracksJSON = (
      await axios.post("/graphql#execute", {
        query:
          "query getTracks($q: BaseScalar!) {tracks(q: $q) {id title description bpm vocal thumbnailUrl coverArt160Url trackFileUrl artistName feelingNames genreNames key genre {name} subgenre {name}}}",
        variables: { q: {} },
        operationName: "getTracks",
      })
    ).data;
    allTracks.value = tracksJSON["data"]["tracks"];
    loading.value = false;
  };

  const selectArtist = function selectArtist(artistName) {
    selectedTrack.value = null;
    filter.value = {
      key: "artist",
      value: artistName,
      title: "Tracks by",
      description: artistName,
    };
  };

  const selectBpm = function selectBpm(bpm) {
    selectedTrack.value = null;
    filter.value = {
      key: "bpm",
      value: bpm,
      title: "Tracks at",
      description: bpm + " BPM",
    };
  };

  const selectFeeling = function selectFeeling(feeling) {
    selectedTrack.value = null;
    if (feeling) {
      filter.value = {
        key: "feeling",
        value: feeling.name,
        title: "Tracks with",
        description: feeling.name,
      };
    } else {
      filter.value = null;
      filteredTracks.value = [];
    }
  };

  const selectGenre = function selectGenre(genreName) {
    selectedTrack.value = null;
    filter.value = {
      key: "genre",
      value: genreName,
      title: "Tracks in",
      description: genreName,
    };
  };

  const selectKey = function selectKey(key) {
    selectedTrack.value = null;
    filter.value = {
      key: "key",
      value: key,
      title: "Tracks in",
      description: key,
    };
  };

  const selectTrack = function selectTrack(track) {
    selectedTrack.value = track;
    playingTrack.value = track;
  };

  return {
    loading,
    allTracks,
    filter,
    selectedTrack,
    playingTrack,
    filteredTracks,
    count,
    isEmpty,
    fill,
    selectArtist,
    selectBpm,
    selectFeeling,
    selectGenre,
    selectKey,
    selectTrack,
  };
});
